import React from "react";
import moment from "moment";
import { watchListUpdateLogType } from "../../../../prop-types/watchListUpdateLogType";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";
const WatchListUpdateReportTableRow = ({ entry }) => {
  return (
    <React.Fragment>
      <tr>
        <td align="center">{entry.watchList.id}</td>
        <td>{entry.watchList.name}</td>
        <td>
          {moment.utc(entry.createDate).local().format("DD.MM.YYYY HH:mm:ss")}
        </td>
        <td align="center" className="watch-list-td-is-active">
          {entry.watchList.isActive ? (
            <FaCheck color="#0AD172" />
          ) : (
            <ImCross color="#FF0000" />
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};
WatchListUpdateReportTableRow.propTypes = {
  entry: watchListUpdateLogType,
};

export default WatchListUpdateReportTableRow;



// WEBPACK FOOTER //
// ./src/features/reports/pages/watch-list-update-report/table/row/WatchListUpdateReportTableRow.jsx